

import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import { Position } from '@/views/interfaces/entities.js';

export default defineComponent({
  name: 'player-info',
  props: {
    avatar: {
      type: String,
      default: '',
    },
    rowspan: {
      type: String,
      default: '1',
    },
    player: {
      type: Object as PropType<Position>,
      default: () => ({
        avatar: 'https://vignette.wikia.nocookie.net/universe-of-smash-bros-lawl/images/4/48/SSB4_random_icon.png',
        match: null,
        votes: 0,
      }),
    },
  },
  computed: {
    playerAvatar(): string {
      return this.avatar;
    },
  },
  methods: {
    selectPlayer() {
      this.$emit('selectPlayer', this.player);
    },
  },
});
